import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

// Measuring-unit master (MeasuringUnit). Cached so any screen can render a unit
// id as its current name (renames in the master propagate automatically).
export const fetchUnits = createAsyncThunk("units/fetchUnits", async (): Promise<any> => {
  const response = await axios.get(`/api/v1/sku/measuring-unit/get`);
  return response.data.measuringUnits;
});
